<template>
    <div id="app">
        <template v-if="compiled && $route.meta.viewport === 'blank'">
            <router-view></router-view>
        </template>
        <template v-if="$route.meta.viewport !== 'blank'">
            <div class="content-wrapper text-center" v-if="maintenance">
                <img :src="'/static/assets/img/maintanence.jpg'"/>
                <br/>
                {{ error_msg }}
            </div>
            <template v-if="compiled && siteType == 'offline'">
                <AuthLogin v-if="generalSession.user && generalSession.user.uid == 0" />
                <template v-if="generalSession.user && generalSession.user.uid > 0">
                    <Header />
                    <router-view></router-view>
                </template>
            </template>

            <template  v-if="compiled && siteType == 'online'">
                <Header />
                <router-view></router-view>
            </template>


        <div v-show="$root.loader || loading" class="Preloader-styles-container"><div class="Spinner-styles-spinner-image"></div><span class="Preloader-styles-label"></span></div>
        <BetSlipWorker v-if="pageLoad >= 5" />
        <CashbackPopUp v-if="pageLoad >= 5 && session.is_sport_cashback_available" />
        </template>

    </div>
</template>

<script>

    import CashbackPopUp from '@/components/CashbackPopUp'
    import Navigation from './Navigation'
    import AuthLogin from '@/components/auth/Login'
    import LoginTop from '@/components/auth/LoginTop'
    import UserPanel from '@/components/user/top/UserPanel'
    import Header from '@/Header'

    import dockTopMenu from './dockTopMenu'
    import VueSticky from 'vue-sticky'
    import globalLoader from '@/components/ui/loader/globalLoader'
    import shapeNotify from '@/components/ui/notify/shapeNotify'
    import BetSlipWorker from '@/components/BetSlipWorker'

    import Resetting from '@/components/user/form/resetting.vue'
    import eventSearch from '@/components/sportsbook/widget/eventSearch'
    import welcomeBonusBanner from '@/components/ui/asset/welcomeBonusBanner'

    export default {
        components: {
            CashbackPopUp,
            BetSlipWorker,
            Header,
            Navigation,
            AuthLogin,
            dockTopMenu,
            LoginTop,
            UserPanel,
            globalLoader,
            Resetting,
            shapeNotify,
            eventSearch,
            welcomeBonusBanner
        },
        directives: {
            'sticky': VueSticky,
        },
        name: 'app',
        data() {
            return {
                compiled: false,
                siteType: window.siteType,
                app: false,
                blurred: true,
                ready: false,
                pageLoad: 0,
                generalSession: [],
                session: [],
                loginBox: false,
                meta: null,
                app_meta: false,
                isLogged: false,
                t: false,
                accessToken: null,
                refreshToken: null,
                dateTimeFormatX: 'Y.M.D HH:mm:ss',
                clientId: null,
                clientSecret: null,
                loading: false,
                maintenance: false,
                locale: 'tr',
                loader: false,
                marketType: [],
                lastMessageFromWS: null,
                WSS: null,
                app_conf: null
            }
        },
        watch: {
            'app'() {
                //this.getClient();
                this.init();
            },
            accessToken() {
                this.getUserSession();
                
            },
            isLogged() {
                this.init();
            },
            '$root.loader'(o, n) {
              this.loader = o
            }

        },
        mounted() {

            this.loading = true;

            if(this.mobileDetect() && this.$route.name != 'PaymentSlipViewer' && this.$route.name != 'TicketViewer' && this.$route.name != 'Login')
                window.location.href = location.protocol+'//m.'+window.location.hostname;
                
            this.getApp()

            //this.fixBodyScroll();

            this.$bus.$on('sessionUpdated', (payload) => {
                this.getUserSession();
            });

            this.$bus.$on('accessToken', (payload) => {
                this.getUserSession();
            });

            this.$bus.$on('globalLoader', (payload) => {

                this.loading = payload;

            });

            this.$getItem('selectedBets', (key, value) => {
                this.$root.selectedOdds = value;

            }, function (err) {

            })

            //setInterval(this.googleTranslateElementInit, 60000);
            setInterval(this.getUserSession, 60000);
            setInterval(this.refreshTokenRoll, 3600000);
            setInterval(this.checkWsConnection, 10000);
            setInterval(this.setBets, 1000);

            this.setBets()
            this.getWs();
        },
        methods: {
            setBets() {
                this.$getItem('bets').then((res) => {
                    window.selectedOdds = res
                })
            },
            logout () {
              this.$setItem('auth', {});

              setTimeout(() => {
                window.location.href = '/';
              }, 500);
            },
            blinkTab() {

                document.addEventListener("visibilitychange", event => {
                    if (document.visibilityState == "visible") {
                        window.windowFocused = true;
                        //console.log("tab is activate")

                    } else {
                        window.windowFocused = false;
                        //console.log("tab is inactive")
                    }
                })
                /*
                window.addEventListener("focus", function(event) {
                    window.windowFocused = true;
                }, false);

                window.addEventListener("blur", function(event) {
                    window.windowFocused = false;

                }, false);
                 */
            },
            mobileDetect() {
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            },
            init() {

                (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
                        g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
                )})(window,document,"script", "/static/sir/widgetloader.js", "SIR", {
                    theme: false, // using custom theme
                    language: 'tr'
                });
                this.getUserSession();
                //this.liveSupportWIdget();
                this.$root.selectedBets = new Array();
            },
            liveSupportWIdget() {
                window.__lc = window.__lc || {};
                window.__lc.license = 11108272;
                (function () {
                    var lc = document.createElement('script');
                    lc.type = 'text/javascript';
                    lc.async = true;
                    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(lc, s);
                })();
            },
            checkWsConnection() {
                var now = new Date(new Date().toUTCString()).getTime();
                if (this.lastMessageFromWS && (now - this.lastMessageFromWS) > 30000){
                    console.log('Websocket has been disconnected')
                    this.WSS.close();
                    this.getWs();
                }
            },
            getWs() {
               // var th = this;
                /*

                window.webs = WS.connect(window.wsapi, {'X-Custom-Header': '...'});

                var th = this;
                webs.on("socket/connect", function (s) {
                    window.wss = s;

                    setInterval(function () {
                        s.subscribe("channel/ping_pong", function (uri, payload) {

                        });
                        s.publish("channel/ping_pong", 1);
                        s.unsubscribe("channel/ping_pong");
                    }, 50000);
                });

                webs.on("socket/disconnect", function (error) {
                    //error provides us with some insight into the disconnection: error.reason and error.code

                    //console.log("Disconnected for " + error.reason + " with code " + error.code);
                });
                */

                
                const ws = new WebSocket('ws://localhost:9999/api/v2/ws')
                //const ws = new WebSocket('wss://stage.plysport.com/api/v2/ws')

                if (window.location.protocol === 'https:') {
                 ws = new WebSocket('wss://ws.plysport.com/api/v2/ws')
                }

                ws.onopen = () => {
                    console.log('ws opened on browser')
                    ws.send('{"action": "subscribe", "state": "ping"}')
                    ws.send('{"action": "subscribe", "state": "live_market"}')
                    ws.send('{"action": "subscribe", "state": "live_match"}')
                }

                ws.onmessage = (message) => {

                    var message = JSON.parse(message.data)

                    if (message.state == "live_match") {
                        this.$store.commit("updateMatch", message.message);
                    }

                    if (message.state == "live_market") {
                        this.$store.commit("updateMarket", message.message);
                    }

                    if (message.state == "ping") {
                        this.lastMessageFromWS = message.ts
                    }
                }
                ws.onclose = function(e) {
                    console.log('Socket is closed. Reconnect will be attempted in 1 second.', e.reason);
                    setTimeout(this.getWs, 1000);
                };
                ws.onerror = function(err) {
                    console.error('Socket encountered error: ', err.message, 'Closing socket');
                    ws.close();
                };
                this.pageLoad += 1;

                this.WSS = ws;

            },
            getTokens() {
                var th = this;
                this.$getItem('auth', function (key, value) {
                    //console.log all the kay/value pairs

                    return value;

                }, function (err) {

                    return false;
                })
            },
            getUserSession(u) {

                var tokens = this.getTokens();

                this.$getItem('session', (key, value) => {
                    //console.log all the kay/value pairs

                    if(value){
                      this.session = value;
                      this.$root.session = value;
                      window.session = value;
                    }

                }, function (err) {

                })


                this.$getItem('auth', (key, a) => {
                    //console.log all the kay/value pairs

                    if (!a) {
                        window.auth.accessToken = null;
                        window.auth.client = null;
                    } else {
                        window.auth = a;
                    }

                    this.$http.get(api + 'api/get/session').then(response => {
                        // get body data
                        this.generalSession = response.body.result;
                        this.$root.session = response.body.result.user;
                        this.meta = response.body.result.app.meta;
                        window.session = response.body.result.user;
                        this.$setItem('session', response.body.result.user);

                        if(window.session && window.session.group && window.session.group.key != "ROLE_CLIENT"){
                            this.logout()
                            this.pageLoad = 0;
                            return
                        }

                        window.document.title = this.meta.title;

                        if (session.timezone) {
                            window.moment.tz.load({
                                zones: [],
                                links: [session.timezone],
                            });
                        }

                        if (window.session) {
                            this.pageLoad += 1;
                        }

                        this.$bus.$emit('Session', response.body.result.user);

                        this.isLogged = (this.$root.session.uid > 0) ? true : false;
                        this.$bus.$emit('globalLoader', false);

                    }, response => {
                        if ((response.status == 404 || response.status == 401) && this.app) {
                            this.$bus.$emit('globalLoader', false);
                            this.$setItem('auth', {});
                            window.session = null;
                            window.location.reload();
                            this.pageLoad += 1;
                        }

                    });

                }, function (err) {

                    this.$bus.$emit('globalLoader', false);
                    this.$setItem('auth', {});
                    this.pageLoad += 1;

                    return false;
                })
            },
            refreshTokenRoll() {

                this.$getItem('auth', (key, value) => {
                    //console.log all the kay/value pairs

                    if (value) {
                        this.$http.get(api + 'oauth/v2/token',
                            {
                                params: {
                                    client_id: value.client,
                                    client_secret: value.clientSecret,
                                    grant_type: 'refresh_token',
                                    refresh_token: value.refreshToken
                                }
                            }).then(
                            response => {

                                window.accessTokenHeader = response.body.access_token;
                                window.auth.accessToken = response.body.access_token;
                                window.auth.refreshToken = response.body.refresh_token;

                                this.$setItem('auth', window.auth);

                            }, response => {
                                window.auth = null;
                                windows.session = null;
                                this.$router.push('/');

                            });
                    }

                }, function (err) {

                })
            },
            getApp() {
                  var hostname = window.location.hostname;

                    if (hostname == 'localhost') {
                        hostname = window.apphost;
                    }

                    this.$http.get(bsapi + 'api/getAppByHostname/' + hostname + '?_=v3').then(response => {
                        var app = response.body.app;
                        //this.app_meta = response.body;

                        if (app) {
                            var socketProtocol = (window.location.protocol === 'https:') ? 'wss://' : 'ws://';
                            //var socketProtocol = 'wss://';
                            //window.api = location.protocol +'//'+ app.hostname + '/';
                            window.api = window.scheme +'//'+ app.hostname + '/';
                            window.wsapi = socketProtocol + app.hostname;
                            window.appId = app.id;
                            this.$root.app = app;
                            this.$root.api = window.scheme +'//'+ app.hostname + '/';
                            this.app = app;
                            this.app_conf = (response.body.conf) ? JSON.parse(response.body.conf) : null;
                            this.$root.app_conf = this.app_conf;
                            this.pageLoad += 1;
                            this.maintenance = false;
                            this.getTranslations()
                        }

                        if (response.status != 200) {
                            this.maintenance = true;
                        }

                    }, response => {
                        // error callback
                        this.maintenance = true;
                    });
            },
            getClient() {

                this.accessToken = window.auth.accessToken;

                console.log('as')

                if (!this.accessToken) {
                    this.$http.get(api + 'api/v1/get/client').then(response => {
                        // get body data
                        this.clientId = response.body.client_id;
                        this.clientSecret = response.body.client_secret;

                        window.auth.client = response.body.client_id;
                        window.auth.clientSecret = response.body.client_secret;
                        this.$setItem('auth', window.auth);

                        this.compiled = 1

                    }, response => {
                        // error callback
                        //this.$cookie.delete('client_id');
                        //this.$cookie.delete('client_secret');
                        this.maintenance = true;
                        this.error_msg = 'Clien couldnt receiver the response.'

                    });
                }else {
                    this.compiled = 1
                }
            },
            getTranslations() {
                return new Promise(resolve => {
                    this.$http.get(bsapi + 'api/v1/translations/get/all?locale='+window.locale,
                        ).then(response => {
                        // get body data
                        this.t = response.body.result.translation;
                        window.t = this.t;
                        this.$root.t = this.t;
                        this.pageLoad += 1;
                        //response.body.result.locale
                        window.moment.locale(window.locale);
                        //window.moment.tz.setDefault("UTC");
                        //this.$router.push({ params: { locale: 'tr' }})
                        var NowMoment = moment().format("dddd, MMMM Do");
                        this.getMarkets()
    

                    }, response => {
                        // error callback
                        if (response.status != 200) {
                            this.maintenance = true;
                        }
                    })
                })
            },
            getMarkets() {
                this.$http.get(bsapi+'api/v2/markets?t=906&locale='+window.locale).then((result) => {
                    result.body.result.forEach(v => {
                        window.marketType['m_'+v.id] = v
                    })

                    this.blinkTab();
                    this.getClient();
                    this.init()
                    //console.log(marketType)
                })

            },
            sessionStop() {
                this.$cookie.delete('client_id');
                this.$cookie.delete('client_secret');
                window.location.reload();
            },
            openForgot() {
                this.$refs.fpmodal.open();
            },

        }

    }
</script>

<style lang="scss">

    @import url('https://fonts.googleapis.com/css2?family=Goldman&display=swap');

    .header-logo {
        flex: 0 0 16.6%;
        max-width: 17%;
    }

    .header-navbar-links {
        flex: 0 0 66%;
        margin: auto;
    }

    .header-user-action {
        flex: 0 0 17%;
        max-width: 17%;
    }

    .content-wrapper {
        width: 1200px;
        margin: 25px auto;
    }

    .bg-blue {
        background: #f64835;
    }

    .tabs-fluid {
        width: 100% !important;
    }

    .app-container {
        padding: 0;
        margin: auto;
    }

    .sport-betting-area .app-container {
        display: flex;
    }

    .page-head {
        min-height: 20px;
        padding: 0 20px;
        position: relative;
        z-index: 2;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    }

    .app-header .btn-white {
        background-color: rgba(255, 255, 255, 0.2);
        border: none;
        color: #fff;
    }

    .app-header .rightNav-item {
        flex: 0 0 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .app-header .rightNav-item .rightNav-icon {
        background-size: 22px 22px;
        height: 22px;
        width: 22px;
        line-height: 22px;
        margin-right: 5px;
    }

    .rightNav-icon.logIn-icon {
        background: url("../static/assets/img/rivalo/logIn-icon.png");
    }

    .rightNav-icon.register-icon {
        background: url("../static/assets/img/rivalo/register-icon.png");
    }

    .top-menu li a {
        font-weight: bold;
    }

    .top-menu {
        background: rgb(34, 147, 119); /* Old browsers */
        position: relative;
        z-index: 2;
    }

    .app-header {
        //background: #3e2950;
        background: #fff;
        z-index: 20;
        margin: auto;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
        position: sticky;
        position: -webkit-sticky;
        top: 10px; /* required */
        width: 1200px;
    }


    .text-logo {
        font-size: 49px;
        color: #ffff;
        height: 55px;
    }

    .footer-w {
        margin: 0;
        float: left;
        width: 100%;
        position: relative;
        bottom: 0;
    }

    /* login box */

    .mini-login {
        width: 600px;
        float: right;
        padding: 0 55px 0 5px;
    }

    .all-wrapper {
        position: relative;

        margin: auto;
    }

    .page-head.LiveBets {
        //background: #ff8600;
    }

    .page-head.Casino {
        background: #000;
    }

    .page-head.LiveCasino {
        background: #bf0153;
    }

    .table.table-padded tbody td a {
        color: #818ba7
    }

    .fade3:before {
        background-image: linear-gradient(90deg, rgba(227, 231, 248, 0) 0%, #2a3145 100%);

    }

    .fade1, .fade3, .fade2 {
        background-image: -webkit-gradient(linear, left top, right top, from(rgba(227, 231, 248, 0)), to(#c7c7c7));
        background-image: linear-gradient(90deg, rgba(227, 231, 248, 0) 0%, #06070a 100%);
    }

    .content-side {
        margin: auto;
    }

    .fillterF {
        font-size: 0.7rem !important;
    }

    .os-tabs-controls {
        margin-bottom: 2rem;
        padding: 0 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }

    .os-tabs-controls .nav-tabs {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }

    .os-tabs-controls .nav-pills {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .nav {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding-left: 0;
        margin-bottom: 0;
        justify-content: center;
        list-style: none;
    }

    .app-header .nav-tabs {
        border: none;
    }

    .app-header .nav-link i {
        font-size: 14px;
        color: green;
    }

    .app-header .nav-tabs .nav-link {
        color: #000;
        line-height: 2;
        font-family: 'Roboto', Helvetica, Arial, sans-serif !important;
        font-size: 14px;
    }

    .nav-tabs .nav-link:after, .nav-tabs .nav-item .nav-link:after {
        background-color: #fff;
    }

    .nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
        cursor: default;
    }

    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link:hover, .nav-tabs .nav-item:hover .nav-link {
        color: #000;
        background-color: transparent;
        border-color: #fff;
        border: 0;
        position: relative;
    }

    .nav-tabs .nav-link {
        border: none;
    }

    #fos_user_registration_form_mobilePhone_country {
        width: 100%;
    }

    @mixin scrollbars($size, $foreground-color, $background-color: mix($foreground-color, white, 50%)) {
        ::-webkit-scrollbar {
            width: $size;
            height: $size;
        }

        ::-webkit-scrollbar-thumb {
            background: $foreground-color;
        }

        ::-webkit-scrollbar-track {
            background: $background-color;
        }

        // For Internet Explorer
        body {
            scrollbar-face-color: $foreground-color;
            scrollbar-track-color: $background-color;
        }
    }

    @include scrollbars(.2em, #f64835);

    .iframe-box {
        width: 100%;
        height: 86vh;
        overflow: auto;
        border: none
    }

    .logoZX {
        padding-top: 10px;
        text-align: center;
        font-weight: normal;
        color: #fff;
        text-transform: uppercase;
        white-space: nowrap;
        font-size: 26px;
        z-index: 1000;
        font-family: 'Bangers', cursive;
        text-shadow: 5px 5px 0 rgba(0, 0, 0, 0.7);
        -moz-transition-property: font-size;
        -o-transition-property: font-size;
        -webkit-transition-property: font-size;
        transition-property: font-size;
        -moz-transition-duration: 0.5s;
        -o-transition-duration: 0.5s;
        -webkit-transition-duration: 0.5s;
        transition-duration: 0.5s;
    }

    option {
        background: #293145;
    }

    .agile__arrow {

    }

    .agile__arrow--next {
        right: 0;
    }

    .agile {
        &__dots {
            bottom: 10px;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
        }

        &__dot {
            margin: 0 12px;

            button {
                background-color: transparent;
                border: 1px solid #fff;

                border-radius: 50%;
                cursor: pointer;
                display: block;
                height: 10px;
                font-size: 0;
                line-height: 0;
                margin: 0;
                padding: 0;
                transition-duration: .3s;
                width: 10px;

                &:hover {
                    background-color: #fff;
                }
            }

            &--current {
                button {
                    background-color: #fff;
                }
            }
        }

        &__arrow {
            border: none;
            height: 100%;
            top: 0;
            width: 80px;
            background-color: transparent;
            position: absolute;
            transition-duration: .3s;
            margin: 0;
            padding: 0;
            width: 50px;

            &:hover {
                background-color: rgba(#000, .5);

                svg {
                    fill: #fff;
                }
            }

            &[disabled] {
                display: none;
            }

            svg {
                fill: rgba(#fff, .4);
                height: 25px;
            }
        }
    }

    .slide {
        background: {
            position: center;
            size: cover;
        }

        &:before {
            //background-color: rgba(#000, .2);
            content: '';
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
        }

        &--1 {
            //background-image: url(../img/bg-1_1.jpg);
        }
    }
    .logo-text, .logo-text:focus, .logo-text:hover {
        font-size: 29px;
        color: white;
        float: left;
        width: 100%;
        line-height: 45px;
        font-family: 'Goldman', cursive;

    }
</style>





// WEBPACK FOOTER //
// src/App.vue